module.exports = __webpack_public_path__ + "static/media/card_6.baa14ef3.png";